export default "__VITE_ASSET__B9p6lYyY__"